import React from "react";
import {
  ExpandableChatBody,
  ExpandableChatFooter
} from "@v2/components/ui/chat/expandable-chat";
import { ChatBotSidebar } from "@webV2/pages/Tessa/ChatBotSidebar";
import { ChatBotConversation } from "@webV2/pages/Tessa/ChatBotConversation";
import { ChatBotPromptInput } from "@webV2/pages/Tessa/ChatBotPromptInput";
import { useAskTessa } from "@v2/components/ai/AskTessaProvider";
import { useChat } from "@ai-sdk/react";

export const ChatBotBubbleBody: React.FC<{
  popupSidebarOpen: boolean;
  setPopupSidebarClosed: () => void;
  chat: ReturnType<typeof useChat>;
}> = ({ popupSidebarOpen, setPopupSidebarClosed, chat }) => {
  const { selectedChatId, setSelectedChatId } = useAskTessa() || {
    selectedChatId: undefined,
    setSelectedChatId: () => {}
  };

  const { messages, sendMessage } = chat;
  const handleSubmit = (text: string) => {
    if (!text) {
      return;
    }

    sendMessage({ text: text.trim() });
  };
  return (
    <>
      <ExpandableChatBody className={"relative"}>
        {popupSidebarOpen && (
          <ChatBotSidebar isBubble setPopupClosed={setPopupSidebarClosed} />
        )}
        {selectedChatId && !popupSidebarOpen && (
          <ChatBotConversation
            key={
              selectedChatId === "new"
                ? `new-${chat.id || "pending"}`
                : selectedChatId
            }
            chatId={selectedChatId === "new" ? chat.id || "" : selectedChatId}
            isThinking={chat.status !== "ready"}
            liveMessages={messages}
            isBubble
          />
        )}
      </ExpandableChatBody>
      {selectedChatId && !popupSidebarOpen && (
        <ExpandableChatFooter>
          <ChatBotPromptInput
            className={"border-1 border-primary-300"}
            handleSubmit={handleSubmit}
            isCompact
          />
        </ExpandableChatFooter>
      )}
    </>
  );
};
